<template>
  <div>
    <div class="page-bg page">
      <SubHeader :title="headerTitle" :isBack="false"></SubHeader>
      <OrderTags :status="status"></OrderTags>
      <div class="main">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item" v-for="item in list" :key="item">
            {{ item }}
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import { List, PullRefresh } from "vant";

Vue.use(List);
Vue.use(PullRefresh);
import SubHeader from "../../../components/sub_header";
import OrderTags from "../../../components/order_tags";

export default {
  name: "order-vantlist",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      headerTitle: "我的订单",
    };
  },
  components: {
    SubHeader,
    OrderTags,
  },

  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 100) {
          this.finished = true;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  padding: 0.48rem 0.3rem;
  box-sizing: border-box;
  height: 50vh;
  overflow-y: auto;
}
.item {
  line-height: 0.6rem;
  text-align: center;
  background: #dcdcdc;
  margin-bottom: 0.2rem;
}
</style>
